import React, { useEffect, useRef } from "react";
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

// Register Chart.js components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels);

const EmployeeCostCenter = ({ costCenters }) => {
  const formattedData = costCenters.map((center) => ({
    name: center.name || "Unassigned",
    count: center.count,
    id: center.id_
  }));

  // Using a single color instead of generating different colors
  const barColor = 'rgb(255 181 3)';
  const borderColor = 'rgb(255 181 3)';
  
  const data = {
    labels: formattedData.map((d) => d.name),
    datasets: [
      {
        label: 'Count',
        data: formattedData.map((d) => d.count),
        backgroundColor: barColor,
        borderColor: borderColor,
        borderWidth: 1,
        borderRadius: 4,
        barPercentage: 0.85,
      }
    ]
  };

  // Calculate minimum width based on number of bars to ensure proper spacing
  const minChartWidth = Math.max(formattedData.length * 50, 300);
  
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    onClick: (event, elements) => {
      if (elements.length > 0) {
        const index = elements[0].index;
        const costCenterId = formattedData[index].id;
        window.open(`/employees?cost_center=${costCenterId}`, '_blank');
      }
    },
    onHover: (event, chartElement) => {
      event.native.target.style.cursor = chartElement.length ? 'pointer' : 'default';
    },
    plugins: {
      datalabels: {
        color: '#fff',  // White text color for data labels
        anchor: 'center',
        align: 'center',
        font: {
          // weight: 'bold',
          size: 12
        },
        formatter: function(value) {
          return value;  // Display the value (count) inside each bar
        }
      },
      legend: {
        display: false,
        position: 'bottom',
      },
      tooltip: {
        mode: 'index',
        intersect: false,
        backgroundColor: '#333',
        titleColor: '#fff',
        bodyColor: '#fff',
        titleFont: {
          size: 12,
        },
        bodyFont: {
          size: 12,
        },
        callbacks: {
          label: function(context) {
            return `${context.parsed.y} Employees`;
          }
        }
      },
    },
    scales: {
      x: {
        ticks: {
          font: {
            size: 10,
          },
          maxRotation: 45,
          minRotation: 45,
        },
      },
      y: {
        beginAtZero: true,
      }
    },
  };

  return (
    <div
      style={{
        width: "100%",
        // maxWidth: "1200px",
        margin: "auto",
        padding: "10px",
        display: "block",
        overflowX: "auto", // Enable horizontal scrolling
      }}
    >
      <div
        style={{
          height: "290px", 
          width: `${minChartWidth}px`, // Ensure minimum width based on data
          minWidth: "100%", // Take up full container width when possible
        }}
      >
        <Bar data={data} options={options} />
      </div>
    </div>
  );
};

export default EmployeeCostCenter;
